/*
 * DISTRIBUSI HP (Liquid Glass) — pure logic for the office screens at phone width: the owner switch +
 * per-user choice, the dock and its + menu, the far-move guard for Atur titik, Google Maps links, the
 * keyboard inset, grouped lists. Isomorphic so every rule is tested in Node; no DOM, no server calls.
 * Spec: docs/superpowers/specs/2026-10-27-distribusi-hp-liquid-glass-design.md
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;   // tests (CommonJS)
  if (root) root.HPLOGIC = api;                                                // browser (global)
})(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function (root) {
  'use strict';
  // distances come from Mode Lapangan's own haversine — one formula for both screens
  var FL = (root && root.FIELDLOGIC) || (typeof require === 'function' ? require('./dist-field-logic.js') : null);
  var hasPt = function (p) { return !!p && typeof p.lat === 'number' && typeof p.lng === 'number' && isFinite(p.lat) && isFinite(p.lng); };

  // SAKELAR — before the owner releases it only the owner may try the new view (lands on old, opts in);
  // after release every phone lands on new and may go back. Un-release wins over a saved 'new'.
  function prefState(o) {
    var rules = (o && o.rules) || {};
    var released = rules.hpUiDefault === 'new';
    var eligible = !!(o && o.phone) && (released || (o && o.role) === 'owner');
    var saved = o && o.saved;
    var ui = !eligible ? 'old' : (saved === 'old' || saved === 'new') ? saved : (released ? 'new' : 'old');
    return { eligible: eligible, released: released, ui: ui };
  }
  function prefKey(userId) { return 'airro.dist.hpUi.' + (userId || 'anon'); }

  // DOCK — Beranda · Pelanggan · [+] · Transaksi · Pengiriman; a tab only for a screen the user may open,
  // the + only with an input cap. Column template matches the tabs (no empty slot).
  var DOCK = [['dist-dashboard', 'home'], ['dist-customers', 'people'], ['dist-transactions', 'swap'], ['dist-deliveries', 'truck']];
  function dockLayout(o) {
    var ids = (o && o.navIds) || []; var p = (o && o.perms) || {};
    var catat = !!(p.distribusiInput || p.distribusiExpense);
    var left = DOCK.slice(0, 2).filter(function (t) { return ids.indexOf(t[0]) >= 0; });
    var right = DOCK.slice(2).filter(function (t) { return ids.indexOf(t[0]) >= 0; });
    var tabs = left.concat(catat ? [null] : [], right);
    return { tabs: tabs, catat: catat, cols: tabs.map(function (t) { return t ? '1fr' : '70px'; }).join(' ') };
  }
  function catatTiles(p) {
    p = p || {};
    var out = [];
    if (p.distribusiInput) {
      out.push({ kind: 'sale', icon: 'drop', tone: 'teal', labelKey: 'dhp.cSale', subKey: 'dhp.cSaleSub' });
      out.push({ kind: 'bon', icon: 'receipt', tone: 'accent', labelKey: 'dhp.cBon', subKey: 'dhp.cBonSub' });
      out.push({ kind: 'damage', icon: 'warn', tone: 'warn', labelKey: 'dhp.cDamage', subKey: 'dhp.cDamageSub' });
    }
    if (p.distribusiExpense) out.push({ kind: 'expense', icon: 'coin', tone: 'neg', labelKey: 'dhp.cExpense', subKey: 'dhp.cExpenseSub' });
    return out;
  }

  // ATUR TITIK from the office — the phone is usually nowhere near the customer, so the guard is the
  // distance from the OLD point (> 150 m → reason); the phone distance only warns when it is ≤ 2 km away.
  var PIN_REASONS = ['wrong', 'moved', 'other'];
  function pinGuard(o) {
    var old = o && o.old; var pin = o && o.pin; var dev = o && o.device;
    var fromOldM = hasPt(old) && hasPt(pin) ? FL.distM(old, pin) : null;
    var devM = hasPt(dev) && hasPt(pin) ? FL.distM(dev, pin) : null;
    return { fromOldM: fromOldM, needReason: fromOldM != null && fromOldM > 150, devM: devM, devWarn: devM != null && devM <= 2000 && devM > 150 };
  }
  function pinNote(reason, text, tr) {
    var t = String(text || '').trim();
    if (reason === 'other') return t;
    if (reason !== 'wrong' && reason !== 'moved') return '';
    var label = tr('dhp.pinR_' + reason);
    return t ? label + ': ' + t : label;
  }

  // GOOGLE MAPS LINK → point. The place pin (!3d…!4d…) beats the camera (@…); short links need a
  // redirect the browser cannot follow (CORS) → { short: true }.
  function okPt(lat, lng) {
    var a = Number(lat); var b = Number(lng);
    return isFinite(a) && isFinite(b) && Math.abs(a) <= 90 && Math.abs(b) <= 180 ? { lat: a, lng: b } : null;
  }
  var NUM = '(-?\\d{1,3}(?:\\.\\d+)?)';
  function parseMapsLink(text) {
    var s = String(text == null ? '' : text).trim();
    if (!s) return null;
    if (/^(https?:\/\/)?(maps\.app\.goo\.gl|goo\.gl\/maps)\//i.test(s)) return { short: true };
    var d = s; try { d = decodeURIComponent(s); } catch (e) { d = s; }
    var m = d.match(new RegExp('!3d' + NUM + '!4d' + NUM));
    if (m) return okPt(m[1], m[2]);
    m = d.match(new RegExp('@' + NUM + ',' + NUM));
    if (m) return okPt(m[1], m[2]);
    m = d.match(new RegExp('[?&](?:q|ll|query)=' + NUM + ',\\s*' + NUM));
    if (m) return okPt(m[1], m[2]);
    m = d.match(new RegExp('^' + NUM + '\\s*,\\s*' + NUM + '$'));
    if (m) return okPt(m[1], m[2]);
    return null;
  }

  // KEYBOARD — how much of the layout viewport the on-screen keyboard covers (visualViewport).
  function kbInset(o) { return Math.max(0, Math.round((o.innerHeight || 0) - (o.vvHeight || 0) - (o.vvTop || 0))); }

  // GROUPED LISTS — per day / month, in the given order, with a subtotal.
  function groupRows(rows, o) {
    var len = o.by === 'month' ? 7 : 10;
    var out = []; var idx = {};
    (rows || []).forEach(function (r) {
      var k = String(o.dateOf(r) || '').slice(0, len);
      if (!(k in idx)) { idx[k] = out.length; out.push({ key: k, rows: [], total: 0 }); }
      var g = out[idx[k]]; g.rows.push(r); g.total += Number(o.amountOf ? o.amountOf(r) : 0) || 0;
    });
    return out;
  }
  function pushRecent(ids, id, max) {
    var n = max || 5;
    return [id].concat((ids || []).filter(function (x) { return x !== id; })).slice(0, n);
  }

  // PENJUALAN (board 3b) — the office sale body the server's txnSchema takes: Lunas = lunas + tunai,
  // Transfer = lunas + transfer (Bank), Bon = bon; clientRef makes a double tap / retry save once.
  function saleBody(o) {
    var b = { customerId: o.cust.id, qty: o.qty, method: o.pay === 'bon' ? 'bon' : 'lunas' };
    if (o.pay !== 'bon') b.payMethod = o.pay === 'transfer' ? 'transfer' : 'tunai';
    b.note = String(o.note || '').trim(); b.txnDate = o.date; b.gallonOut = o.out; b.gallonIn = o.inn; b.clientRef = o.ref;
    if (o.photo && o.photo.id) { b.proofPhotoId = o.photo.id; b.proofTakenAt = o.photo.takenAt; if (o.photo.lat != null) { b.proofLat = o.photo.lat; b.proofLng = o.photo.lng; } }
    return b;
  }
  function saleTotal(qty, price) { return (Number(qty) || 0) * (Number(price) || 0); }
  function saleProblem(o) {
    if (!o.cust) return 'dhp.needCust';
    if (!(Number(o.qty) > 0)) return 'dhp.needQty';
    if (o.needPhoto && !(o.photo && o.photo.id)) return 'dhp.needPhoto';
    return '';
  }

  // BAYAR BON / GANTI RUGI / PENGELUARAN — the bodies the old office forms send (DistTransactions
  // commitPay / commitExpense, GantiRugiForm), plus a clientRef so a retry saves once.
  function proofOf(photo) {
    var b = {};
    if (photo && photo.id) { b.proofPhotoId = photo.id; b.proofTakenAt = photo.takenAt; if (photo.lat != null) { b.proofLat = photo.lat; b.proofLng = photo.lng; } }
    return b;
  }
  function bonBody(o) {
    var b = Object.assign({ customerId: o.cust.id, method: 'pelunasan', payAmount: o.amount, payMethod: o.pay === 'transfer' ? 'transfer' : 'tunai', note: String(o.note || '').trim(), txnDate: o.date, clientRef: o.ref }, proofOf(o.photo));
    if (o.targets && o.targets.length) b.bonTargets = o.targets.slice();   // pelunasan untuk bon tertentu (none = oldest first)
    return b;
  }
  function bonProblem(o) {
    if (!o.cust) return 'dhp.needCust';
    if (!(Number(o.amount) > 0)) return 'dhp.needAmt';
    if (Number(o.amount) > (Number(o.cust.sisaBon) || 0)) return 'dhp.overSisa';
    if (o.needPhoto && !(o.photo && o.photo.id)) return 'dhp.needPhoto';
    return '';
  }
  function damageBody(o) {
    var b = { qty: o.qty, kind: o.kind, payMethod: o.pay, txnDate: o.date, clientRef: o.ref };
    if (o.plan && o.plan.nego) b.total = o.plan.amount;
    if (o.pay === 'transfer' && o.tfPhoto && o.tfPhoto.id) b.transferProofId = o.tfPhoto.id;
    if (o.dmgPhoto && o.dmgPhoto.id) b.photoId = o.dmgPhoto.id;
    var n = String(o.note || '').trim(); if (n) b.note = n;
    return b;
  }
  function damageProblem(o) {
    if (!o.cust) return 'dhp.needCust';
    if (!o.kind) return 'dhp.needKind';
    if (!(Number(o.qty) > 0)) return 'dhp.needQty';
    if (o.held != null && Number(o.qty) > Number(o.held)) return 'gr.errQty';
    if (o.price == null) return 'dhp.loadingPrice';
    if (o.plan && o.plan.blocked) return o.plan.blocked;
    if (o.needPhoto && !(o.dmgPhoto && o.dmgPhoto.id)) return 'dhp.needPhoto';
    return '';
  }
  function expenseBody(o) {
    var b = { date: o.date };
    if (o.fleet) b.fleet = o.fleet;
    b.amount = o.amount; b.category = String(o.category || '').trim() || 'lainnya'; b.method = o.method === 'transfer' ? 'transfer' : 'tunai';
    var r = String(o.recipient || '').trim(); if (r) b.recipient = r;
    var n = String(o.note || '').trim(); if (n) b.note = n;
    if (o.photo && o.photo.id) b.photoId = o.photo.id;
    b.clientRef = o.ref;
    return b;
  }
  function expenseProblem(o) {
    if (!(Number(o.amount) > 0)) return 'dhp.needAmt';
    if (!o.scoped && !o.fleet) return 'dhp.needFleet';
    if (o.needPhoto && !(o.photo && o.photo.id)) return 'dhp.needPhoto';
    return '';
  }

  return { bonBody: bonBody, bonProblem: bonProblem, damageBody: damageBody, damageProblem: damageProblem, expenseBody: expenseBody, expenseProblem: expenseProblem,
    saleBody: saleBody, saleTotal: saleTotal, saleProblem: saleProblem, prefState: prefState, prefKey: prefKey, dockLayout: dockLayout, catatTiles: catatTiles, PIN_REASONS: PIN_REASONS, pinGuard: pinGuard, pinNote: pinNote, parseMapsLink: parseMapsLink, kbInset: kbInset, groupRows: groupRows, pushRecent: pushRecent };
});
